// Play / App Store links: see storeLink() in utils/storeLinks.js.

/**
 * Coin redemption at checkout. Off until the coin economy (grants, earn-back,
 * expiry, repricing) ships in one go. While off, the coin card and slider stay
 * on screen as designed but the slider is pinned at 0 and disabled, and no
 * coins are sent to the backend, so every order pays the full Fleek price.
 */
export const COINS_REDEMPTION_ENABLED = false;
